import { useMutation } from '@tanstack/react-query';

import {
  useRequest,
  type MutationFunction,
  RunesCallout,
  PrintExtraction,
} from '@frontend/api';

type CreatePrintExtractionVariables = {
  callout: RunesCallout;
  fileUuid: string;
  pageNumber: number;
};

export const useCreatePrintExtraction: MutationFunction<
  PrintExtraction,
  CreatePrintExtractionVariables
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ callout, fileUuid, pageNumber }) => {
      const urlPath = `/parts/files/${fileUuid}/pages/${pageNumber}/print_extractions`;

      return request(urlPath, {
        init: {
          method: 'POST',
          body: callout,
        },
      });
    },
    ...queryOptions,
    mutationKey: ['createPrintExtraction'],
  });
};
